<template>
	<div class="fill-height bg">
		<top-toolbar :routes="routes" :isConnected="isConnected" :isManager="isManager" :user="user"></top-toolbar>
		<v-content>
			<v-container class="fill-height" fluid>
				<v-row align-content="center" justify="center">
					<v-col cols="12" xl="9" lg="10">
						<router-view></router-view>
					</v-col>
				</v-row>
			</v-container>
		</v-content>
	</div>
</template>

<script>
import TopToolbar from "src/scaffoldings/TopToolbar";

export default {
	components: {
		TopToolbar
	},
	props: {
		source: String
	},
	data: () => ({
		drawer: false
	}),
	computed: {
		config() {
			return this.$store.state.ConfigModule;
		},
		user() {
			return this.$store.state.AuthModule.user;
		},
		defaultRouter() {
			return this.config.routes.default;
		},
		routes() {
			return this.config.routes.routes[this.defaultRouter].routes;
		},
		isManager() {
			return this.$store.getters.isManager;
		},
		isConnected() {
			return this.$store.getters.isConnected;
		}

	},
	created() {
		if (window.innerWidth > 1264) {
			this.drawer = true;
		}
	}
};
</script>

<style>


</style>
